import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgxEchartsModule } from "ngx-echarts";
import { CaseNumberComponent } from "./case-number/case-number.component";
import { VicDetailsTableComponent } from "./vic-details-table/vic-details-table.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatInputModule } from "@angular/material/input";
import { VicDetailsMapComponent } from "./vic-details-map/vic-details-map.component";

@NgModule({
  declarations: [
    AppComponent,
    CaseNumberComponent,
    VicDetailsTableComponent,
    MatPaginator,
    VicDetailsMapComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxEchartsModule,
    MatFormFieldModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatInputModule
  ],
  exports: [
    MatPaginator,
    MatFormFieldModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatInputModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
